export const getScan = (chain: string, tHash: string): string => {
  if (chain === '0x1') return  `https://etherscan.io/tx/${tHash}`
  if (process.env.NODE_ENV === 'production') {
    return `https://ftmscan.com/tx/${tHash}`
  }
  return `https://testnet.snowtrace.io/tx/${tHash}`
}
